/*
 * @Author: w
 * @Date: 2022-03-31 10:25:27
 * @LastEditors: w
 * @LastEditTime: 2022-04-03 11:54:57
 */
export function setToken (token:string) {
  localStorage.setItem('__token__', token)
}

export function getToken () {
  return localStorage.getItem('__token__') || ''
}

export function removeToken () {
  localStorage.removeItem('__token__')
}


export function setUserId (token:string) {
  localStorage.setItem('__userId__', token)
}

export function getUserId () {
  return localStorage.getItem('__userId__') || ''
}

export function removeUserId () {
  localStorage.removeItem('__userId__')
}
export function setRefreshToken (reFreshToken:string) {
  localStorage.setItem('__refreshToken__',reFreshToken)
}
export function getReFreshToken () {
 return localStorage.getItem('__refreshToken__')||''
}
export function removeReFreshToken () {
  localStorage.removeItem('__refreshToken__')
}